import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { Helmet } from 'react-helmet';
import 'react-table/react-table.css';
import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components';
import { requestServiceTypes, deleteServiceType } from '../../../store/services-manager/ServicesManagerActions';
import { requestClientsTypeahead } from '../../../store/client-manager/ClientManagerActions';
import LocationsFilterForm from '../../resource-library/components/LocationsFilterForm';
import Pagination from '../../../components/common/Pagination';
import InfoBar from '../../../components/common/InfoBar';
import { hashHistory } from 'react-router';
import { hostTitle } from '../../../config/ui';

class ServiceTypeManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: 25,
      page: 0,
      pages: -1,
      search: '',
      sorted: [],
      filtered: [],

    };
    this.changeFilters = this.changeFilters.bind(this);
  }

  searchClients = (search) => {
    return this.props
      .clientsTypeahead({
        tenantId: this.props.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ code: item.code, name: item.name }),
          );
        }
        return options;
      });
  };

  fetchData = (state) => {
    const offset = state.page * state.pageSize;
    const limit = state.pageSize;
    const order = state.sorted
      .map((item) => `${item.desc ? 'desc' : 'asc'} ${item.id}`)
      .join();
    const filters = state.filtered
      .map((item) => `${item.value} ${item.id}`)
      .join();
    const search = this.state.search;
    return this.props
      .getServiceTypes({
        offset: offset,
        limit: limit,
        order: order,
        search: search,
        filters: filters,
        tenantId: this.props.tenantId,
        companies: state.location ? state.location.provider : [],
      })
      .then((response) =>
        this.setState({
          pages: response.payload
            ? Math.ceil(response.payload.data.total / this.state.pageSize)
            : 0,
        }),
      );
  };

  handleSearch = (search) =>
    this.setState({ search, page: 0 }, () => this.table.fireFetchData());

  editServiceType = (id) => {
    hashHistory.push(`/service-manager/service/${id}`);
  };

  addServiceType = (id) => {
    hashHistory.push(`/service-manager/service/${id}`);
  };

  deleteServiceType = (id) => {
    this.props
      .deleteServiceType(id, {
        tenantId: this.props.tenantId,
      })
      .then(() => this.table.fireFetchData()
      );
  };

  changeFilters(params) {
    this.setState({ location: { ...this.location, ...params } }, () => this.fetchData(this.state));
  }
  
  render() {
    const { data, isExecutive } = this.props;

    return (
      <div id="content">
        <Helmet title={`Services Manager – ${hostTitle()}`} />
        <div className="table-layout content-ribbon">
          <div className="table-cell">
            <BigBreadcrumbs
              items={['Service Request Manager', 'Services Manager']}
              icon="fa fa-fw fa-map"
              className=""
            />
          </div>
          <div className="table-cell">
            <InfoBar
              className=""
              total={data.total}
              pages={this.state.pages}
              page={this.state.page + 1}
            />
          </div>
        </div>
        <WidgetGrid>
          <div className="row">
            <article className="col-sm-12">
              <JarvisWidget
                color="white"
                fullscreenbutton={true}
                colorbutton={false}
                editbutton={false}
                togglebutton={false}
                deletebutton={false}
              >
                <header>
                  <span className="widget-icon">
                    {' '}
                    <i className="fa fa-table" />{' '}
                  </span>{' '}
                  <h2>Services Manager</h2>
                </header>
                <div>
                  <div className="widget-body no-padding">
                    <div
                      style={{ padding: 10, borderBottom: '1px solid #eeeeee' }}
                    >
                      <div className="row">
                        <div className="col-md-3" >
                          <LocationsFilterForm searchLocations={this.searchClients} isMulti={true} onSubmit={this.changeFilters} />
                        </div>
                        <div className="widget-toolbar">
                          <button disabled={isExecutive}
                            className="btn btn-primary btn-xs"
                            onClick={() => this.addServiceType('00000000-0000-0000-0000-000000000000')}
                          >
                            Add Service Type
                          </button>
                        </div>
                      </div>
                    </div>
                    <ReactTable
                      ref={(instance) => {
                        this.table = instance;
                      }}
                      page={this.state.page}
                      manual
                      pages={this.state.pages}
                      loading={this.props.isLoading}
                      data={this.props.data ? this.props.data.list : []}
                      onFetchData={this.fetchData}
                      columns={[
                        
                        {
                          Header: 'ID',
                          id: 'id',
                          accessor: 'id',
                          show: false,
                        },
                        {
                          Header: 'Service Name',
                          id: 'name',
                          accessor: 'name',
                          Cell: (row) => (
                            <a
                              onClick={() =>
                                this.editServiceType(
                                  row.original.id
                                )
                              }
                            >
                              {row.original.name}
                            </a>
                          ),
                        },
                        {
                          Header: 'Forms',
                          Cell: (row) => (
                            <span>{row.original.files.length}</span>
                          ),
                        },
                        {
                          Header: '',
                          id: 'actions',
                          width: 65,
                          sortable: false,
                          Cell: (row) => (
                            <span>
                              <button disabled={isExecutive}
                                className="btn btn-default btn-xs"
                                onClick={() => this.deleteServiceType(row.original.id)}>
                                <i className="fa fa-trash" />
                              </button>
                            </span>
                          ),
                        },
                      ]}
                      defaultPageSize={this.state.pageSize}
                      onPageSizeChange={(pageSize) =>
                        this.setState({ pageSize })
                      }
                      onPageChange={(page) => this.setState({ page })}
                      //filterable
                      className="-striped -highlight"
                      showPaginationTop={false}
                      PaginationComponent={Pagination}
                      //onSearchChange={this.handleSearch}
                    />
                   
                  </div>
                </div>
              </JarvisWidget>
            </article>
          </div>
        </WidgetGrid>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    ...state.servicemanager,
    tenantId: state.currentUser.queryParams.tenantId,
  }),
  (dispatch) => ({
    getServiceTypes: (params) => dispatch(requestServiceTypes(params)),
    clientsTypeahead: (params) => dispatch(requestClientsTypeahead(params)),
    deleteServiceType: (id, params) => dispatch(deleteServiceType(id, params)),
  }),
)(ServiceTypeManager);



// WEBPACK FOOTER //
// ./src/routes/service-request-manager/containers/ServiceTypeManager.js